angular.module('cfn').directive('cfnVendorProductId', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'E',
      scope: {
        details: '=',
        ctrl: '=',
        change: '&'
      },
      templateUrl: require('./cfn-vendor-product-id.tpl.html'),
      link: function(scope) {
        scope.showAmazoneManufacturerModel = function() {
          if (scope.details) {
            if (
              scope.details.sysManufacturer &&
              scope.details.sysManufacturer.code == 348
            ) {
              if (
                !scope.details.vendorProductId ||
                $rootScope.enums.AmazoneManufacturerModelEnum.options.indexOf(
                  scope.details.vendorProductId
                ) === -1
              ) {
                // CFNPOC-11227 ISO XML bundle has a mapping of names to types. Until we support this, user has to
                // manually select the type. If he didn't show OTHER.
                scope.details.vendorProductId = 'OTHER';
              }
              return true;
            } else {
              return false;
            }
          }
        };
      }
    };
  }
]);
